var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

$(document).ready(function () {

  var screenWidth = screen.width;

  var $vanillaCarousel = $('.carousel') // This is the Bootstrap carousel, not used
  if ($vanillaCarousel.length) {
    $('.carousel').carousel({
      interval: 8000,
      on: {
        ready: () => {
          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        },
        select: () => {
          document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
            el.removeAttribute('tabindex');
          })

          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        }
      }
    });
  }

  $('.generic-video-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'left',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: 2,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    setGallerySize: false,
    prevNextButtons: $('.generic-video-carousel').find('.carousel-cell').length > 1 ? true : false,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.provider-video-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: 2,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    prevNextButtons: $('.provider-video-carousel').find('.carousel-cell').length > 1 ? true : false,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.blog-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: 1,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    setGallerySize: false,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.academics-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: true,
    imagesLoaded: true,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.research-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: true,
    imagesLoaded: true,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  var $homeQuotes = $('.www-quote-carousel');

  $homeQuotes.on('ready.flickity', function () {
    $('#promotion-quote-sliders').fadeIn(4000);
  });

  $homeQuotes.flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: 1,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    setGallerySize: false,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.lp-carousel').flickity({
    autoPlay: 6000,
    cellAlign: 'center',
    contain: true,
    draggable: '>1',
    dragThreshold: 8,
    freeScroll: false,
    initialIndex: 0,
    lazyLoad: 1,
    pageDots: false,
    selectedAttraction: 0.03,
    friction: 0.5,
    wrapAround: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  $('.provider-carousel').flickity({
    cellAlign: 'left',
    contain: true,
    lazyLoad: 1,
    pageDots: false,
    wrapAround: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });

  /***** Card carousels for newly designed home and service line pages *****/

  // Promos card carousel (new homepage)
  $('#carousel-promos .card-carousel').flickity({
    cellAlign: 'left',
    draggable: '>1', // false
    contain: true,
    lazyLoad: 1,
    pageDots: false,
    wrapAround: true,
    groupCells: '100%',
    percentPosition: false,
    prevNextButtons: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('#carousel-promos .card-carousel-cell[aria-hidden="true"] a, #carousel-promos .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('#carousel-promos .card-carousel-cell.is-selected a, #carousel-promos .card-carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('#carousel-promos .card-carousel-cell[aria-hidden="true"] a, #carousel-promos .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });
  $(function() {
    const $carousel = $('#carousel-promos .card-carousel').flickity();
    const flkty = $carousel.data('flickity');
    $('#carousel-promos .card-carousel-prev').on('click', function () {
      $carousel.flickity('previous');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-promos .card-carousel-prev img');
        if ($('#carousel-promos').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-promos .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $('#carousel-promos .card-carousel-next').on('click', function () {
      $carousel.flickity('next');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-promos .card-carousel-prev img');
        if ($('#carousel-promos').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-promos .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $carousel.on('change.flickity', function (event, index) {
      const $prevImg = $('#carousel-promos .card-carousel-prev img');
      if ($('#carousel-promos').hasClass('card-carousel-theme-dark')) {
        $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
      } else {
        $prevImg.attr('src', '/assets/img/static/arrow.svg');
      }
      $('#carousel-promos .card-carousel-prev').attr('style', 'cursor: pointer;');
    });
  });

  // Recommended Content entries card carousel based on persona (new homepage)
  $('#carousel-recommended-content .card-carousel').flickity({
    cellAlign: 'left',
    draggable: '>1', // false
    contain: true,
    lazyLoad: 1,
    pageDots: false,
    wrapAround: true,
    groupCells: '100%',
    percentPosition: false,
    prevNextButtons: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('#carousel-recommended-content .card-carousel-cell[aria-hidden="true"] a, #carousel-recommended-content .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('#carousel-recommended-content .card-carousel-cell.is-selected a, #carousel-recommended-content .card-carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('#carousel-recommended-content .card-carousel-cell[aria-hidden="true"] a, #carousel-recommended-content .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });
  $(function() {
    const $carousel = $('#carousel-recommended-content .card-carousel').flickity();
    const flkty = $carousel.data('flickity');
    $('#carousel-recommended-content .card-carousel-prev').on('click', function () {
      $carousel.flickity('previous');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-recommended-content .card-carousel-prev img');
        if ($('#carousel-recommended-content').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-recommended-content .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $('#carousel-recommended-content .card-carousel-next').on('click', function () {
      $carousel.flickity('next');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-recommended-content .card-carousel-prev img');
        if ($('#carousel-recommended-content').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-recommended-content .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $carousel.on('change.flickity', function (event, index) {
      const $prevImg = $('#carousel-recommended-content .card-carousel-prev img');
      if ($('#carousel-recommended-content').hasClass('card-carousel-theme-dark')) {
        $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
      } else {
        $prevImg.attr('src', '/assets/img/static/arrow.svg');
      }
      $('#carousel-recommended-content .card-carousel-prev').attr('style', 'cursor: pointer;');
    });
  });

  // Related Content card carousel (new service line pages)
  $('#carousel-related-content .card-carousel').flickity({
    cellAlign: 'left',
    draggable: '>1', // false
    contain: true,
    lazyLoad: 1,
    pageDots: false,
    wrapAround: true,
    groupCells: '100%',
    percentPosition: false,
    prevNextButtons: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('#carousel-related-content .card-carousel-cell[aria-hidden="true"] a, #carousel-related-content .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('#carousel-related-content .card-carousel-cell.is-selected a, #carousel-related-content .card-carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('#carousel-related-content .card-carousel-cell[aria-hidden="true"] a, #carousel-related-content .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });
  $(function() {
    const $carousel = $('#carousel-related-content .card-carousel').flickity();
    const flkty = $carousel.data('flickity');
    $('#carousel-related-content .card-carousel-prev').on('click', function () {
      $carousel.flickity('previous');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-related-content .card-carousel-prev img');
        if ($('#carousel-related-content').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-related-content .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $('#carousel-related-content .card-carousel-next').on('click', function () {
      $carousel.flickity('next');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-related-content .card-carousel-prev img');
        if ($('#carousel-related-content').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-related-content .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $carousel.on('change.flickity', function (event, index) {
      const $prevImg = $('#carousel-related-content .card-carousel-prev img');
      if ($('#carousel-related-content').hasClass('card-carousel-theme-dark')) {
        $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
      } else {
        $prevImg.attr('src', '/assets/img/static/arrow.svg');
      }
      $('#carousel-related-content .card-carousel-prev').attr('style', 'cursor: pointer;');
    });
  });
  
  // Related Content card carousel (new service line detail pages)
  $('#carousel-related-videos .card-carousel').flickity({
    cellAlign: 'left',
    draggable: '>1', // false
    contain: true,
    lazyLoad: 1,
    pageDots: false,
    wrapAround: true,
    groupCells: '100%',
    percentPosition: false,
    prevNextButtons: false,
    imagesLoaded: true,
    on: {
      ready: () => {
        document.querySelectorAll('#carousel-related-videos .card-carousel-cell[aria-hidden="true"] a, #carousel-related-videos .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      },
      select: () => {
        document.querySelectorAll('#carousel-related-videos .card-carousel-cell.is-selected a, #carousel-related-videos .card-carousel-cell.is-selected button').forEach((el) => {
          el.removeAttribute('tabindex');
        })

        document.querySelectorAll('#carousel-related-videos .card-carousel-cell[aria-hidden="true"] a, #carousel-related-videos .card-carousel-cell[aria-hidden="true"] button').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    }
  });
  $(function() {
    const $carousel = $('#carousel-related-videos .card-carousel').flickity();
    const flkty = $carousel.data('flickity');
    $('#carousel-related-videos .card-carousel-prev').on('click', function () {
      $carousel.flickity('previous');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-related-videos .card-carousel-prev img');
        if ($('#carousel-related-videos').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-related-videos .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $('#carousel-related-videos .card-carousel-next').on('click', function () {
      $carousel.flickity('next');
      if (flkty.selectedIndex > 0) {
        const $prevImg = $('#carousel-related-videos .card-carousel-prev img');
        if ($('#carousel-related-videos').hasClass('card-carousel-theme-dark')) {
          $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
        } else {
          $prevImg.attr('src', '/assets/img/static/arrow.svg');
        }
        $('#carousel-related-videos .card-carousel-prev').attr('style', 'cursor: pointer;');
      }
    });
    $carousel.on('change.flickity', function (event, index) {
      const $prevImg = $('#carousel-related-videos .card-carousel-prev img');
      if ($('#carousel-related-videos').hasClass('card-carousel-theme-dark')) {
        $prevImg.attr('src', '/assets/img/static/arrow-blue.svg');
      } else {
        $prevImg.attr('src', '/assets/img/static/arrow.svg');
      }
      $('#carousel-related-videos .card-carousel-prev').attr('style', 'cursor: pointer;');
    });
  });

});
